import "./App.css";
import { ToastContainer } from "react-toastify";
import AppRouter from "./router/AppRouter";
import MobileUnsupportedModal from "./components/MobileUnsupportedModal/MobileUnsupportedModal";
import React, { useEffect, useState } from "react";
import "@aws-amplify/ui-react/styles.css";
import { fetchAuthSession } from "aws-amplify/auth";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [needsOTPVerification, setNeedsOTPVerification] = useState(false);
  const [needsRoleSelection, setNeedsRoleSelection] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const checkAuthSession = async () => {
      try {
        const session = await fetchAuthSession();
        const token = localStorage.getItem("userAccessToken");

        // Check if the session has valid tokens
        if (session.tokens?.accessToken || token) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log("No authenticated session:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthSession();
  }, []);

  if (isLoading) {
    return (
      <div className="app-container">
        <div className="loading-section">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <ToastContainer position="top-right" />
      <MobileUnsupportedModal />
      <div className="app-container">
        <AppRouter
          isAuthenticated={isAuthenticated || false}
          setIsAuthenticated={setIsAuthenticated}
          needsOTPVerification={needsOTPVerification}
          setNeedsOTPVerification={setNeedsOTPVerification}
          needsRoleSelection={needsRoleSelection}
          setNeedsRoleSelection={setNeedsRoleSelection}
          userEmail={userEmail}
          setUserEmail={setUserEmail}
        />
      </div>
    </div>
  );
}

export default App;
